import * as recycleConst from './constants';

export default {
    [recycleConst.kecDescribeInstances](state, res) {
        state.list = res.list
        state.total = res.total
    },
    [recycleConst.kecGetProjList](state, data) {
        state.kecGetProjList = data;
    }
};
